import { render, staticRenderFns } from "./FromCreatedForm.vue?vue&type=template&id=517c3ecc&scoped=true&"
import script from "./FromCreatedForm.vue?vue&type=script&lang=js&"
export * from "./FromCreatedForm.vue?vue&type=script&lang=js&"
import style0 from "./FromCreatedForm.vue?vue&type=style&index=0&id=517c3ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c3ecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('517c3ecc')) {
      api.createRecord('517c3ecc', component.options)
    } else {
      api.reload('517c3ecc', component.options)
    }
    module.hot.accept("./FromCreatedForm.vue?vue&type=template&id=517c3ecc&scoped=true&", function () {
      api.rerender('517c3ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/components/FromCreatedForm.vue"
export default component.exports